import styled from 'styled-components';
import { Type } from "../Type";
export var TypeListItem = styled(Type.li).withConfig({
  displayName: "TypeListItem",
  componentId: "q1l2mf-0"
})(["display:list-item;padding-block-end:", ";"], function (props) {
  return !props.condensed && '1em';
});
/**
* **TypeListItem** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeListItem) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-type-typelistitem--default) | [Encore](https://encore.spotify.net/web/components/type?format=figma-figma#list-text) | 
*
* TypeListItem is an individual unit in the TypeList
*
* @example
* () => <TypeListItem>Aenean lacinia</TypeListItem>;
*
*/

export default TypeListItem;